import { useCallback, useEffect, useMemo, useState } from 'react';
import { autoCompleteRegions, resetAutocomplete, selectAutoCompleteRegions } from '../feature';
import { useAppDispatch, useAppState } from '@/store';
import debounce from 'lodash.debounce';

export const useAutocompleteRegions = (defaultRegionName = '', defaultLimit = 0) => {
  const [isLoading, setIsLoading] = useState(false);
  const regions = useAppState(selectAutoCompleteRegions);
  const dispatch = useAppDispatch();

  const handleSearch = useCallback(
    debounce(async (search: string, limit = defaultLimit) => {
      try {
        setIsLoading(true);
        await dispatch(
          autoCompleteRegions({
            search,
            limit,
          }),
        );
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }, 500),
    [defaultLimit, dispatch],
  );

  useEffect(() => {
    handleSearch(defaultRegionName);
  }, [handleSearch, defaultRegionName]);

  useEffect(() => {
    return () => {
      dispatch(resetAutocomplete());
      handleSearch.cancel();
    };
  }, []);

  return useMemo(
    () => ({
      regions: regions ?? [],
      regionsOptions: regions?.map((region) => ({ label: region.name ?? '', value: region.id })),
      isLoading,
      onSearch: handleSearch,
    }),
    [regions, isLoading, handleSearch],
  );
};
